<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Objetivos do Contrato</mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxFlexFill>
                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <input #nomeObjetivo matInput maxlength="100" name="nomeObjetivo"
                           placeholder="Nome do Objetivo" [(ngModel)]="objetivoContrato.nome" required="true">
                    <mat-hint align="end">{{ nomeObjetivo.value.length }} / 100</mat-hint>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxFlexFill>
                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <input #descricaoObjetivo matInput maxlength="1000" name="descricaoObjetivo"
                           placeholder="Descrição" [(ngModel)]="objetivoContrato.descricao">
                    <mat-hint align="end">{{ descricaoObjetivo.value.length }} / 1000</mat-hint>
                </mat-form-field>
            </div>

            <mat-toolbar class="titulopartes" style="margin-top: 10px; margin-bottom: 10px;"><span>Metas do Objetivo</span>
            </mat-toolbar>
            <div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px;" fxFlexFill>
                <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoMetasObjetivo">
                    <div *ngFor="let metaObjetivo of objetivoContrato.metasObjetivo; let index = index">
                        <formulario-meta-objetivo [metaObjetivo]="metaObjetivo"
                                                  [index]="index"
                                                  [metasObjetivo]="objetivoContrato.metasObjetivo"
                                                  [perfilAcesso]="perfilAcesso">
                        </formulario-meta-objetivo>
                    </div>
                    <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
                         style="padding-top: 10px; padding-left: 20px;">
                        <div>
                            <button matTooltip="Nova Meta" mat-mini-fab color="primary" (click)="addMetaObjetivo()"
                                    style="width: 100px;border-radius: 5px;">
                                <mat-icon>add</mat-icon>
                                Meta
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                 style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button mat-raised-button name="botaoAdicionar" fxFlex="20%"
                        color="primary" (click)="adicionar()" *ngIf="!isAtualizarObjetivo" [disabled]="formulario.invalid">
                    Adicionar
                </button>
                <button mat-raised-button name="botaoAlterar" fxFlex="20%"
                        color="primary" (click)="alterar()" *ngIf="isAtualizarObjetivo" [disabled]="formulario.invalid">
                    Alterar
                </button>


            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
                             (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Objetivos ( {{ listaObjetivosContrato?.length }} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                   style="margin-top: 20px">

                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef> Nome</th>
                    <td mat-cell *matCellDef="let element"> {{ element.nome }}</td>
                </ng-container>

                <ng-container matColumnDef="descricao">
                    <th mat-header-cell *matHeaderCellDef> Descrição</th>
                    <td mat-cell *matCellDef="let element"> {{ element.descricao }}</td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações</th>
                    <td mat-cell *matCellDef="let element">
                        <button *ngIf="perfilAcesso.deleta && listaObjetivosContrato?.length >= 1" mat-button
                                (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.altera" mat-button (click)="irAtualizar(element)">
                            <mat-icon>edit</mat-icon>
                        </button>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{ msg }}
                </div>
            </ng-template>

            <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                 style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar novo objetivo" mat-fab color="primary" (click)="irNovo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>

    </mat-accordion>
</form>